<template>
  <a
    target="_blank"
    :href="`https://www.google.com/maps/place/${address}`"
    :class="['google-map', { 'show-circle': showCircle }, { 'show-mask': !hasPosition }]"
    :style="`width:${width}px;height:${height}px;backgroundImage:url(${imageURL})`"
  >
    <div class="google-map__circle" :style="`width:${circleRadius}px;height:${circleRadius}px;`"></div>
  </a>
</template>
<script>
export default {
  name: 'GoogleStaticMap',
  props: {
    // 地图宽度
    width: {
      type: Number,
      default: 200,
    },
    // 地图高度
    height: {
      type: Number,
      default: 200,
    },
    // 地图缩放比例
    zoom: {
      type: Number,
      default: 15,
    },
    // 位置信息
    position: {
      type: Object,
    },
    // 是否显示详细地址
    detailVisible: {
      default: false,
    },

    address: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      // 谷歌地图基础地址
      baseURL: '/gg/v1/staticMap',
      // 谷歌地图是否加载完成
      preloaded: false,
    };
  },
  computed: {
    // 谷歌地图静态图片地址
    imageURL() {
      const baseURL = this.baseURL;
      const width = this.width;
      const height = this.height;
      const zoom = this.zoom;
      const detailVisible = Boolean(this.detailVisible);
      let lat = 43.65332780000001;
      let lng = -79.38403079999999;
      if (this.hasPosition) {
        lat = this.position.lat;
        lng = this.position.lng;
      }

      return detailVisible
        ? `${baseURL}?size=${width}x${height}&zoom=${zoom}&markers=${lat},${lng}`
        : `${baseURL}?size=${width}x${height}&zoom=${zoom}&center=${lat},${lng}`;
    },
    // 计算圆的直径
    circleRadius() {
      const width = this.width;
      const height = this.height;
      const minSide = width > height ? height : width;
      const radius = Math.ceil(minSide * 0.8);
      return radius;
    },
    // 是否传递位置数据
    hasPosition() {
      const position = this.position;
      return position && position.lat && position.lng;
    },
    // 是否显示圆
    showCircle() {
      return this.hasPosition && this.preloaded && !this.detailVisible;
    },
  },
  watch: {
    imageURL: {
      immediate: true,
      handler(url) {
        this.preloaded = false;
        this.imagePreload(url, () => {
          this.preloaded = true;
        });
      },
    },
  },
  methods: {
    /**
     * 图片预加载
     */
    imagePreload(src, callback) {
      let imageEl = new Image();
      imageEl.src = src;
      if (imageEl.complete) {
        callback({ width: imageEl.width, height: imageEl.height, status: 'complete' });
        imageEl = null;
      } else {
        imageEl.onload = function() {
          callback({ width: imageEl.width, height: imageEl.height, status: 'onload' });
          imageEl = null;
        };
        imageEl.onerror = function() {
          console.error('图片加载失败', src);
          callback({ width: 0, height: 0, status: 'onerror' });
          imageEl = null;
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.google-map {
  display: block;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  &.show-mask {
    &::after {
      content: '';
      position: absolute;
      top: -15%;
      left: -15%;
      bottom: -15%;
      right: -15%;
      background: inherit;
      filter: blur(8px) contrast(0.9);
      z-index: 2;
    }
  }
  &.show-circle {
    .google-map__circle {
      display: block;
      pointer-events: none;
    }
  }
}
.google-map__circle {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: none;
}
</style>
